"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameModeTransitionController = void 0;
const EventHandler_1 = require("../../../core/event/EventHandler");
const GameEvent_1 = require("../../../core/event/GameEvent");
const ServerEvent_1 = require("../../../core/server/event/ServerEvent");
const ParsedInitData_1 = require("../../../core/server/data/ParsedInitData");
const GameModeEvent_1 = require("../../../core/gamemode/event/GameModeEvent");
const BetLineEvent_1 = require("../../../core/betline/event/BetLineEvent");
const SlotGame_1 = require("../../../core/SlotGame");
class GameModeTransitionController {
    set onFinishCallback(value) {
        this._onFinishCallback = value;
    }
    get isTriggered() {
        return this._isTriggered;
    }
    get isTriggeredThisSpin() {
        return this._isTriggeredThisSpin;
    }
    get serverData() {
        return this._serverData;
    }
    constructor(fromMode, toMode) {
        this._fromMode = fromMode;
        this._toMode = toMode;
        this.addEventListeners();
    }
    addEventListeners() {
        EventHandler_1.EventHandler.addEventListener(this, ServerEvent_1.ServerEvent.GAME_DATA_PARSED, (event) => this.onGameDataParsed(event.params[0]));
        EventHandler_1.EventHandler.addEventListener(this, ServerEvent_1.ServerEvent.INIT_DATA_PARSED, (event) => this.onInitDataParsed(event.params[0]));
    }
    onInitDataParsed(data) {
        EventHandler_1.EventHandler.removeEventListener(this, ServerEvent_1.ServerEvent.INIT_DATA_PARSED);
        this.onGameDataParsed(data);
    }
    onGameDataParsed(data) {
        this._serverData = data;
        this._isTriggered = this.calculateIsTriggered(data);
    }
    calculateIsTriggered(data) {
        const isRestoreState = (data instanceof ParsedInitData_1.ParsedInitData) ? data.isRestoreState : false;
        const restoreThisMode = isRestoreState && data.nextMode == this._toMode;
        this._isTriggeredThisSpin = this.calculateIsTriggeredThisSpin(data);
        return restoreThisMode || this._isTriggeredThisSpin;
    }
    calculateIsTriggeredThisSpin(data) {
        return this._fromMode == data.mode && this._toMode == data.nextMode;
    }
    /**
     * When overriding:
     *
     * this.prepareToEnterMode(); It dispatches the GameModeEvent.GAME_MODE_TRANSITION_PREPARE event that can be used as a point for views to update and switch gfx for the new game mode.
     * You need to call this at some point when you are ready for it. For example when the screen is covered by some image or Graphics so that the rearrangement is not visible to the end user.
     *
     * Call finish(), when all animations and such is done.
     *
     */
    start() {
        this.prepareToEnterMode();
        this.finish();
    }
    /**
     * Function to prepare things before entering the new game mode. Needs to be called in start();
     *
     * Be sure to run super.prepareToEnterMode() when overriding.
     *
     */
    prepareToEnterMode() {
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(GameModeEvent_1.GameModeEvent.CHANGE_MODE, { newMode: this._serverData.nextMode })); //TODO - remove this and use GAME_MODE_TRANSITION_PREPARE instead. 
        EventHandler_1.EventHandler.dispatchEvent(new GameModeEvent_1.GameModeEvent(GameModeEvent_1.GameModeEvent.GAME_MODE_TRANSITION_PREPARE, this._fromMode, this._toMode));
        //TODO - these don't belong here, maybe the hide keypad does but not the others. They should take care of themselves. Maybe listen to the SCREEN_START / SCREEN_CLOSED events.
        this.hideKeypad();
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(BetLineEvent_1.BetLineEvent.SET_ENABLED, false));
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(BetLineEvent_1.BetLineEvent.HIDE_ALL_BET_LINES));
    }
    /**
     * Call this to finish the transition.
     *
     * You should not override this for cleanup, instead do cleanup in cleanUpBeforeModeStart();
     *
     */
    finish() {
        this.cleanUpBeforeModeStart();
        this._onFinishCallback(this);
    }
    /**
     * Used for cleanup before the new mode is started
     *
     * Be sure to run super when overriding.
     */
    cleanUpBeforeModeStart() {
        this.showKeypad();
        EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(BetLineEvent_1.BetLineEvent.SET_ENABLED, true));
    }
    shouldOnlyHideKeypadButtons() {
        return false;
    }
    hideKeypad() {
        SlotGame_1.SlotGame.keypad.hide();
        /*    if(this.shouldOnlyHideKeypadButtons()) {
                SlotGame.Keypad.hideLandscapeButtons();
            } else {
                Keypad.fadeOut();
            }*/
    }
    showKeypad() {
        SlotGame_1.SlotGame.keypad.show();
        /*
        if(this.shouldOnlyHideKeypadButtons()) {
            Keypad.showLandscapeButtons();
        } else {
            Keypad.fadeIn();
        }*/
    }
}
exports.GameModeTransitionController = GameModeTransitionController;
//# sourceMappingURL=GameModeTransitionController.js.map